import { useEffect } from 'react';
import { Toaster } from 'sonner';
import { useTheme } from '@/hooks/useTheme';
import { useUIMode } from '@/context/UIModeContext';

/**
 * Syncs Sonner toaster and document theme side effects.
 */
export function ThemeSync() {
  const { resolvedTheme } = useTheme();
  const { uiMode } = useUIMode();

  useEffect(() => {
    document.documentElement.dataset.theme = resolvedTheme;
  }, [resolvedTheme]);

  if (uiMode === 'invisible') {
    return null; // Silenced in invisible mode
  }

  return (
    <Toaster 
      position="bottom-right" 
      richColors={uiMode === 'explicit'} 
      closeButton={uiMode === 'explicit'} 
      theme={resolvedTheme}
      toastOptions={
        uiMode === 'ambient' 
          ? { style: { opacity: 0.8, scale: 0.9, backdropFilter: 'blur(8px)', background: 'var(--khiimori-bg-elevated)', border: '1px solid var(--khiimori-border)' } } 
          : undefined
      }
    />
  );
}
